type SocialNetworkTitleProps = { children: React.ReactNode };

const SocialNetworkTitle = ({ children }: SocialNetworkTitleProps) => {
	return <div className={`vtex-store-footer-2-x-socialNetworksTitle mb4`}>{children}</div>;
};

export default SocialNetworkTitle;
